/* eslint-disable no-unused-vars */
import { Grid } from "@mui/material";
import PDialog from "../../../components/pos/PDialog";
import PText from "../../../components/pos/PText";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { PricingUtils } from "../../../utils/PricingUtils";
import { PrintUtils } from "../../../utils/PrintUtils";
import { SaleUtils } from "../../../utils/SaleUtils";
import PDigitPanel from "../../../components/pos/PDigitPanel";
export const DayOpenDialog = (props) => {
  const { t } = useTranslation();
  const translate = t;

  //export default function SaleWindow(props) {

  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [saveInProgress, setSaveInProgress] = useState(false);

  function onCloseWindow() {
    props.setShowDayOpen(false);
  }

  async function onSave() {
    setSaveInProgress(true);

    let amt = "0.00";
    if (parseFloat(amount) > 0) {
      amt = amount;
    }
    PricingUtils.formattedNumber(amt, props.context.store.currencyDecimal);
    try {
      let { data } = await API.post("/api/v1/salesession/start", {
        terminalKey: props.terminalBean.terminalKey,
        amount: amt,
        saleSessionId: props.saleSession ? props.saleSession.id : null,
        shiftMode: props.shiftMode,
      });
      let dataToPrint = {};
      if (props.shiftMode) {
        dataToPrint = SaleUtils.getShiftSaleSession(data);
      } else {
        dataToPrint = data;
      }
      await props.checkSaleFlow();
      onCloseWindow();
      try {
        await PrintUtils.printReceipt(
          props.terminalBean,
          props.shiftMode ? "SHIFT_OPEN_PRINT_FORMAT" : "DAY_OPEN_PRINT_FORMAT",
          dataToPrint,
          props.setAlert,
          true,
          translate,
          false,
          false,
          null,
          props.pdfViewer
        );

        await PrintUtils.openDrawer(
          props.terminalBean,
          props.setAlert,
          translate
        );
      } catch (err) {
        console.log(err);
      }
      setSaveInProgress(false);
    } catch (err) {
      setSaveInProgress(false);
      props.showMessage("error", "Error While Starting Sale Session");
    }
  }
  function onKeyPressed(keyCode) {
    let v = getValue(amount, keyCode);
    setAmount(v);
  }

  function getValue(currentValue, key) {
    if ("Backspace" === key) {
      if (currentValue.length > 0) {
        return getSubStr(currentValue);
      }
      return currentValue;
    } else {
      if ("." === key) {
        if (currentValue.includes(".")) {
          return currentValue;
        }
      }
      return currentValue + key;
    }
  }

  function getSubStr(str) {
    let s = str.substring(0, str.length - 1);
    if (s.endsWith(".")) {
      s = s.substring(0, s.length - 1);
    }
    return s;
  }

  function onDelete() {}
  const content = (
    <Grid container>
      <Grid item xs={6}>
        {translate("Cash in Hand")}
      </Grid>
      <Grid item xs={6}>
        <PText
          value={amount}
          autoFocus={true}
          //type="number"
          error={amountError}
          onChange={(e) => {
            if (!isNaN(e.target.value)) {
              setAmount(e.target.value);
              setAmountError("");
            }
          }}
        ></PText>
      </Grid>
      <Grid xs={12} sx={{ pt: "10px" }}>
        <PDigitPanel onKeyPressed={onKeyPressed} />
      </Grid>
    </Grid>
  );
  return (
    <div>
      <PDialog
        content={content}
        title={
          props.shiftMode ? translate("Shift Open") : translate("Day Open")
        }
        maxWidth={"md"}
        fullWidth={false}
        open={true}
        onCloseWindow={onCloseWindow}
        onSave={onSave}
        saveLabel={
          props.shiftMode ? translate("Start Shift") : translate("Start Sale")
        }
        mode={"create"}
        saveDisabled={saveInProgress}
        isSaveLoaderEnabled={saveInProgress}
      ></PDialog>
    </div>
  );
};
export default DayOpenDialog;
